// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/DashboardCard.js
//
// Purpose:
// Reusable Dashboard Card Wrapper
//
// Standard ERP Dashboard Styling
// ======================================================================

import React from "react";

export default function DashboardCard({

  title,

  subtitle,

  children,

  actions = null,

  height = null,

  style = {},

}) {

  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        padding: 18,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.06)",

        height,

        ...style,
      }}
    >

      {(title || subtitle || actions) && (

        <div
          style={{
            display: "flex",

            justifyContent:
              "space-between",

            alignItems: "flex-start",

            marginBottom: 15,
          }}
        >

          <div>

            {title && (

              <div
                style={{
                  fontSize: 16,

                  fontWeight: 700,

                  color: "#111827",
                }}
              >
                {title}
              </div>

            )}

            {subtitle && (

              <div
                style={{
                  fontSize: 13,

                  color: "#6b7280",

                  marginTop: 4,
                }}
              >
                {subtitle}
              </div>

            )}

          </div>

          {actions}

        </div>

      )}

      {children}

    </div>

  );
}